<template>
  <loadingComponent ref="loadingComponent" :loading-text="$t('loading')">
    <div class="wl-container">
      <div class="table-responsive">
        <table class="excel-table-2007 fixed-width-table table-hover">
          <thead class="thead-light-blue">
            <tr>
              <th
                v-for="(column, key) in columns"
                :key="`columns-th-colspan-${key}`"
                :class="typeof column.width !== typeof undefined ? `text-center established-width-${column.width}` : 'text-center established-width-150'"
                :colspan="column.colspan"
              >{{ column.title }}</th>
              <th v-if="showActionsColumn" :class="`text-center established-width-${stateWidth}`"></th>
            </tr>
            <tr>
              <th
                v-for="(column, key) in subColumns"
                :key="`columns-td-${key}`"
                class="text-center"
                :class="`established-width-${stateWidth}`"
              >
                {{ column.title }}
              </th>
              <th v-if="showActionsColumn" :class="`text-center established-width-${stateWidth}`"></th>
            </tr>
          </thead>
          <tbody v-if="getObjectSize(rows) > 0">
            <tr
              v-for="(row, index) in rows"
              :key="`rows-tr-${index}`"
              :id="generateRandomNumber(20)"
            >
              <td
                v-for="(column, key) in row"
                :key="`rows-td-${key}`"
                :style="(force !== undefined && force && column.styles !== undefined) ? column.styles : ''"
                :colspan="checkColspan(column)"
              >
                <template v-if="(!Array.isArray(column) && column.editable) && (inspeccion) || (!Array.isArray(column) && column.type === 'checkbox')">
                  <vue-weirdotab :data="column" @changeData="getEventChangedData" :index="index" :inspeccion="inspeccion"></vue-weirdotab>
                </template>
                <template v-else>
                  <template v-if="Array.isArray(column)">
                    <table class="fixed-width-table">
                      <tr>
                        <td
                          v-for="(fcolumn, fkey) in column"
                          :key="`rows-td-${key}-${fkey}`"
                          :class="`text-center established-width-${stateWidth}`"
                        >
                          <template v-if="(!Array.isArray(fcolumn) && fcolumn.editable) && (inspeccion) || (!Array.isArray(fcolumn) && fcolumn.type === 'checkbox')">
                            <vue-weirdotab :data="fcolumn" @changeData="getEventChangedData" :index="index" :inspeccion="inspeccion && fcolumn.visible"></vue-weirdotab>
                          </template>
                          <template v-else>
                            <p class="text-center">{{ fcolumn.value }}</p>
                          </template>
                        </td>
                      </tr>
                    </table>
                  </template>
                  <template v-else>
                    <p class="text-center">{{ column.value }}</p>
                  </template>
                </template>
              </td>
              <td v-if="showActionsColumn" :class="`text-center established-width-${stateWidth}`">
                <tr class="remove-border noBreakWords">
                  <td v-if="determinesInspectionAction(['delete']) && force !== undefined && force">
                    <a
                      href="javascript:void(0)"
                      class="text-primary"
                      @click="deleteRow(row)"
                    >
                      <icon name="minus-circle" size="fa-1x"></icon>
                    </a>
                  </td>
                  <template v-if="showActions !== undefined && showActions">
                    <td v-if="hasDocument(row, 'infra')">
                      <a
                        :href="renderUrl(getDocument(row, 'infra'))"
                        target="_blank"
                        class="btn btn-dark btn-sm width8"
                      >
                        Ver {{ getDocument(row, 'tag_infra') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'salud')">
                      <a
                        :href="renderUrl(getDocument(row, 'salud'))"
                        target="_blank"
                        class="btn btn-dark btn-sm width8"
                      >
                        Ver {{ getDocument(row, 'tag_salud') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'bombero')">
                      <a
                        :href="renderUrl(getDocument(row, 'bombero'))"
                        target="_blank"
                        class="btn btn-dark btn-sm width8"
                      >
                        Ver {{ getDocument(row, 'tag_bombero') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'municipio')">
                      <a
                        :href="renderUrl(getDocument(row, 'municipio'))"
                        target="_blank"
                        class="btn btn-dark btn-sm width8"
                      >
                        Ver {{ getDocument(row, 'tag_municipio') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'segregacion')">
                      <a
                        :href="renderUrl(getDocument(row, 'segregacion'))"
                        target="_blank"
                        class="btn btn-dark btn-sm width8"
                      >
                        Ver {{ getDocument(row, 'tag_segregacion') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'infra')">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-danger btn-sm width9"
                        @click="resetPermit(row, 'infra')"
                      >
                        Eliminar {{ getDocument(row, 'tag_infra') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'salud')">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-danger btn-sm width9"
                        @click="resetPermit(row, 'salud')"
                      >
                        Eliminar {{ getDocument(row, 'tag_salud') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'bombero')">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-danger btn-sm width9"
                        @click="resetPermit(row, 'bombero')"
                      >
                        Eliminar {{ getDocument(row, 'tag_bombero') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'municipio')">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-danger btn-sm width9"
                        @click="resetPermit(row, 'municipio')"
                      >
                        Eliminar {{ getDocument(row, 'tag_municipio') }}
                      </a>
                    </td>
                    <td v-if="hasDocument(row, 'segregacion')">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-danger btn-sm width9"
                        @click="resetPermit(row, 'segregacion')"
                      >
                        Eliminar {{ getDocument(row, 'tag_segregacion') }}
                      </a>
                    </td>
                  </template>
                </tr>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="alert alert-danger">
              <td
                :colspan="getObjectSize(columns)"
                class="text-center"
              >{{ $t('there_is_no_information') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </loadingComponent>
</template>

<script>
import ComponentLoading from './Componentloading'
import IncludeHelperComponent from '../plugins/includeHelperComponent'
import { objectToFormData } from '../plugins/objectToFormData'
import axios from 'axios'

export default {
  name: 'v-weirdo-table-policies',
  extends: IncludeHelperComponent,
  components: {
    loadingComponent: ComponentLoading,
  },
  props: ['inspeccion', 'columns', 'mutable', 'force', 'limit', 'rows', 'showActions','filesUri', 'module', 'typeAttachedDocumentsAmount'],
  computed: {
    subColumns: function() {
      const columns = []
      this.columns.forEach(column => {
        const { columns: headers } = column
        if (headers && headers.length > 0) {
          headers.forEach(header => {
            columns.push(header)
          })
        }
      })

      return columns
    },
    stateWidth: function () {
      if (this.showActions !== undefined && this.showActions) {
        if (this.typeAttachedDocumentsAmount > 0) {
          return this.typeAttachedDocumentsAmount * 220
        }
      }

      if (this.force !== undefined && this.force) {
        return 50
      }

      return 50
    },
    showActionsColumn: function () {
      if ((this.force !== undefined && this.force) || (this.showActions !== undefined && this.showActions)) {
        return true
      }

      return false
    },
  },
  methods: {
    getEventChangedData(data) {
      this.$emit('addExecutionEvent', data)
    },
    getObjectSize(data) {
      return this.checkVariable(data) ? Object.keys(data).length : 0
    },
    deleteRow(row) {
      if (Array.isArray(row)) {
        row.forEach((r, index) => {
          if (Array.isArray(r)) {
            r.forEach(rValue => {
              this.$set(rValue, 'visible', false)
            })
          } else {
            this.$set(r, 'visible', false)
            if (r.styles === undefined) {
              this.$set(
                r,
                'styles',
                {
                  background: '#dcabab',
                  color: '#000',
                },
              )
            }
          }
        })
      }
    },
    checkColspan(columns) {
      if (Array.isArray(columns)) {
        return columns.length
      }

      return 1
    },
    getDocument(row, document_name) {
      const objectDocument = this.getTheFirstOccurrenceByKey(this.filesUri, row[0].id, 'id')

      if (this.checkVariable(objectDocument)) {
        return objectDocument[document_name]
      }

      return null
    },
    hasDocument(row, document_name) {
      const objectDocumentFiles = this.getTheFirstOccurrenceByKey(this.filesUri, row[0].id, 'id')

      if (this.checkVariable(objectDocumentFiles)) {
        if (this.checkVariable(objectDocumentFiles[document_name])) {
          return true
        }
      }

      return false
    },
    resetPermit(row, document_name) {
      const _this = this
      const document = row[0]

      if (this.checkVariable(document)) {
        const { id } = document
        const params = objectToFormData({ id, document_name })
        axios
          .post(`/api/permission/${this.module}/reset_document`, params)
          .then(function(response) {
            if (_this.checkVariable(response) && _this.checkVariable(response.data) && response.data === 'ok') {
              _this.defaultSettingsToastSwal()
              _this.swalTitle = _this.$t('update_response')
              _this.swalText = undefined
              _this.positionedDialogToast()
              _this.$store.dispatch('setUpdateStatus', _this.generateRandomNumber(10))
              _this.$emit('click')
            }
          })
      }
    },
  },
}
</script>
<style scoped>
.noBreakWords {
  word-break: initial;
}
.width8 {
  width: 8em;
}
.width9 {
  width: 9em;
}
</style>
